import { pointHistoryResource, PointHistoryResource } from '@witkac/kartamiejska-resources';
import { PointHistory } from '@witkac/kartamiejska-shared';

import { EntityListModule } from '../entityList.module';

/**
 * Moduł historii punktów klienta
 *
 * @class ClientPointHistoryModule
 * @extends {EntityListModule<PointHistory, PointHistoryResource>}
 */
class ClientPointHistoryModule extends EntityListModule<PointHistory, PointHistoryResource> {}

export default new ClientPointHistoryModule(pointHistoryResource);
